"use strict";

var conversions = require("webidl-conversions");

var utils = require("./utils.js");

var impl = utils.implSymbol;

var EventTarget = require("./EventTarget.js");

function XMLHttpRequestEventTarget() {
  throw new TypeError("Illegal constructor");
}

Object.setPrototypeOf(XMLHttpRequestEventTarget.prototype, EventTarget.interface.prototype);
Object.setPrototypeOf(XMLHttpRequestEventTarget, EventTarget.interface);
Object.defineProperty(XMLHttpRequestEventTarget, "prototype", {
  value: XMLHttpRequestEventTarget.prototype,
  writable: false,
  enumerable: false,
  configurable: false
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, "onloadstart", {
  get: function get() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    return utils.tryWrapperForImpl(this[impl]["onloadstart"]);
  },
  set: function set(V) {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    V = utils.tryImplForWrapper(V);
    this[impl]["onloadstart"] = V;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, "onprogress", {
  get: function get() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    return utils.tryWrapperForImpl(this[impl]["onprogress"]);
  },
  set: function set(V) {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    V = utils.tryImplForWrapper(V);
    this[impl]["onprogress"] = V;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, "onabort", {
  get: function get() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    return utils.tryWrapperForImpl(this[impl]["onabort"]);
  },
  set: function set(V) {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    V = utils.tryImplForWrapper(V);
    this[impl]["onabort"] = V;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, "onerror", {
  get: function get() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    return utils.tryWrapperForImpl(this[impl]["onerror"]);
  },
  set: function set(V) {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    V = utils.tryImplForWrapper(V);
    this[impl]["onerror"] = V;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, "onload", {
  get: function get() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    return utils.tryWrapperForImpl(this[impl]["onload"]);
  },
  set: function set(V) {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    V = utils.tryImplForWrapper(V);
    this[impl]["onload"] = V;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, "ontimeout", {
  get: function get() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    return utils.tryWrapperForImpl(this[impl]["ontimeout"]);
  },
  set: function set(V) {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    V = utils.tryImplForWrapper(V);
    this[impl]["ontimeout"] = V;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, "onloadend", {
  get: function get() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    return utils.tryWrapperForImpl(this[impl]["onloadend"]);
  },
  set: function set(V) {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }

    V = utils.tryImplForWrapper(V);
    this[impl]["onloadend"] = V;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(XMLHttpRequestEventTarget.prototype, Symbol.toStringTag, {
  value: "XMLHttpRequestEventTarget",
  writable: false,
  enumerable: false,
  configurable: true
});
var iface = {
  // When an interface-module that implements this interface as a mixin is loaded, it will append its own `.is()`
  // method into this array. It allows objects that directly implements *those* interfaces to be recognized as
  // implementing this mixin interface.
  _mixedIntoPredicates: [],
  is: function is(obj) {
    if (obj) {
      if (utils.hasOwn(obj, impl) && obj[impl] instanceof Impl.implementation) {
        return true;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = module.exports._mixedIntoPredicates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var isMixedInto = _step.value;

          if (isMixedInto(obj)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    return false;
  },
  isImpl: function isImpl(obj) {
    if (obj) {
      if (obj instanceof Impl.implementation) {
        return true;
      }

      var wrapper = utils.wrapperForImpl(obj);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = module.exports._mixedIntoPredicates[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var isMixedInto = _step2.value;

          if (isMixedInto(wrapper)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    return false;
  },
  convert: function convert(obj) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$context = _ref.context,
        context = _ref$context === void 0 ? "The provided value" : _ref$context;

    if (module.exports.is(obj)) {
      return utils.implForWrapper(obj);
    }

    throw new TypeError("".concat(context, " is not of type 'XMLHttpRequestEventTarget'."));
  },
  create: function create(constructorArgs, privateData) {
    var obj = Object.create(XMLHttpRequestEventTarget.prototype);
    obj = this.setup(obj, constructorArgs, privateData);
    return obj;
  },
  createImpl: function createImpl(constructorArgs, privateData) {
    var obj = Object.create(XMLHttpRequestEventTarget.prototype);
    obj = this.setup(obj, constructorArgs, privateData);
    return utils.implForWrapper(obj);
  },
  _internalSetup: function _internalSetup(obj) {
    EventTarget._internalSetup(obj);
  },
  setup: function setup(obj, constructorArgs, privateData) {
    if (!privateData) privateData = {};
    privateData.wrapper = obj;

    this._internalSetup(obj);

    Object.defineProperty(obj, impl, {
      value: new Impl.implementation(constructorArgs, privateData),
      writable: false,
      enumerable: false,
      configurable: true
    });
    obj[impl][utils.wrapperSymbol] = obj;

    if (Impl.init) {
      Impl.init(obj[impl], privateData);
    }

    return obj;
  },
  interface: XMLHttpRequestEventTarget,
  expose: {
    Window: {
      XMLHttpRequestEventTarget: XMLHttpRequestEventTarget
    },
    DedicatedWorker: {
      XMLHttpRequestEventTarget: XMLHttpRequestEventTarget
    },
    SharedWorker: {
      XMLHttpRequestEventTarget: XMLHttpRequestEventTarget
    }
  }
}; // iface

module.exports = iface;

var Impl = require("../xhr/XMLHttpRequestEventTarget-impl.js");